import { html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './toggle.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

// @ts-ignore
export default class Toggle extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      /**
       * toggle callback function
       */
      onChange: { type: Function },
      /**
       * toggle { id: String, label: String, icon: String }
       */
      activeItem: { type: Object },
      /**
       * toggle ActiveItem[]
       */
      items: { type: Array },
    };
  }

  // connectedCallback() {
  //   if (this.activeItem.id === '' && this.items.length > 0) {
  //     this.activeItem = this.items[0];
  //   }
  // }

  constructor() {
    super();
    this.items = [];
    this.activeItem = { id: '' };
  }

  _onClick(item) {
    this.activeItem = item;

    if (this.onChange) {
      this.onChange(item);
    }
    this.requestUpdate();
  }

  /**
   * sets the activeItem to the first index if activeItem was not provided
   */
  firstUpdated() {
    if (this.activeItem.id === '' && this.items.length > 0) {
      const [first] = this.items;
      this.activeItem = first;
      this.update();
    }
  }

  render() {
    return html`<div class="toggle">
      ${this.items.map(
        item => html`
          <button
            id=${item.id}
            class="${classMap({
              'toggle__item': true,
              'toggle__item--active': this.activeItem.id === item.id,
            })}"
            @click=${() => this._onClick(item)}
          >
            <hf-icon name="${item.icon}" class="toggle__item--icon"></hf-icon>
            <div>${item.label}</div>
          </button>
        `
      )}
      <!-- Use for adding extra buttons not part of the clickable callback -->
      <slot></slot>
    </div> `;
  }
}

customElements.define('hf-toggle', Toggle);
